var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinkflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 367.439,
    height: 156.421,
    viewBox: "0 0 367.439 156.421",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M15,277.7V145.809s88.457-59.352,238.155,6.595c0,0,61.24,19.784,129.284-6.595V277.7Z",
    transform: "translate(-15 -121.281)",
    fill: "#fe6684"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkflow);
export default __webpack_public_path__ + "static/media/pinkflow.ef5405fe58d5dff7d61546a32bcc484a.svg";
export { ForwardRef as ReactComponent };